module.exports = __webpack_public_path__ + "img/IMG_2614_T_L_Wood.c2ac429a.jpg";